import * as React from 'react';
import { Button, Col, Container, Input, Row } from 'reactstrap';
import AdminCoursesTableBox from 'src/components/adminAllCourses/AdminCoursesTableBox';
import { TR } from 'src/TextRes';
import {
    ApiCourseActivate,
    ApiCourseCsv,
    ApiCourseDeactivate,
    ApiCourseList,
    ApiCourseProvidersAutoSuggest,
    CourseListLine,
    CourseProviderAutoSuggestListResult,
    CourseProvidersAutoSuggestResult,
    CoursesListParams,
    ServerResponse,
} from '../../api';
import DateRangeInput from '../../components/dateRangeInput/DateRangeInput';
import Footer from '../../components/footer/Footer';
import HeaderLoggedIn from '../../components/headerLoggedIn/HeaderLoggedIn';
import LiveSearchInput from '../../components/liveSearchInput/LiveSearchInput';
import { ModalMessageToEmail } from '../../components/modalMessageToEmail/ModalMessageToEmail';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import Paging from '../../components/paging/Paging';
import { IThConfig } from '../../components/sortableTh/SortableTh';
import { IEmptyProps, ISortIcon } from '../../constants';
import './AdminAllCourses.css';

interface IState {
    loading: boolean;
    listData: CourseListLine[];
    openModalMessage: boolean;
    serverResponse?: ServerResponse;
    searchParams: CoursesListParams;
    sortIcon: ISortIcon[];
    totalCount: number;
    emailToCourseProvider: string;
    courseProviderID: string;
    courseProviderMail: string;
    courseActive: boolean;
    collapsed: boolean;
}

export default class AdminAllCourses extends React.Component<IEmptyProps, IState> {
    private renderTHeadLineArrays: IThConfig[] = [
        { sortField: 'courseProviderName', name: 'Kursanbieter', width: '15%' },
        { sortField: 'insertDate', name: 'Anlegedatum', width: '5%' },
        { sortField: 'title', name: 'Kursname', width: '30%' },
        { sortField: 'lecturerName', name: 'Dozent', width: '10%' },
        { sortField: 'published', name: 'Status', width: '5%' },
        { sortField: 'disabled', name: 'Aktiv', width: '5%' },
    ];
    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            collapsed: true,
            courseActive: false,
            courseProviderID: '',
            courseProviderMail: '',
            emailToCourseProvider: '',
            listData: [],
            loading: true,
            openModalMessage: false,
            searchParams: {
                CourseProviderId: '',
                Descending: true,
                EndDate: '',
                Offset: 0,
                PageSize: 50,
                Search: '',
                Sort: 'insertDate',
                StartDate: '',
            },
            serverResponse: undefined,
            sortIcon: [],
            totalCount: 0,
        };
    }

    public componentDidMount() {
        const mySortIcon = this.state.sortIcon;
        this.renderTHeadLineArrays.map(() => {
            mySortIcon.push(0);
        });
        this.setState({ sortIcon: [...mySortIcon] }, () => {
            this.searchCourses();
        });
    }

    public render() {
        const {
            courseActive,
            courseProviderMail,
            loading,
            openModalMessage,
            searchParams,
            serverResponse,
            totalCount,
        } = this.state;

        return (
            <NetworkOverlay loading={loading} serverResponse={serverResponse}>
                <HeaderLoggedIn />
                <Container>
                    <Row>
                        <Col className={'searchLine'}>
                            <LiveSearchInput
                                placeholder="Kursanbieter suchen..."
                                onFetchRequest={(search, callback) => {
                                    ApiCourseProvidersAutoSuggest(
                                        {
                                            Search: search,
                                        },
                                        (sr: ServerResponse & { Data: CourseProviderAutoSuggestListResult }) => {
                                            if (sr.OK) {
                                                callback(sr.Data.CourseProviders);
                                            } else {
                                                callback([]);
                                            }
                                        }
                                    );
                                }}
                                onClear={() => {
                                    this.changeValue('CourseProviderId', '', true, true);
                                }}
                                renderSuggestion={(suggestion: CourseProvidersAutoSuggestResult) => {
                                    return <span>{suggestion.Name}</span>;
                                }}
                                getSuggestionValue={(suggestion: CourseProvidersAutoSuggestResult) => {
                                    this.changeValue('CourseProviderId', suggestion.ID, true, true);
                                    return suggestion.Name;
                                }}
                            />
                            <div>
                                <input
                                    name="CourseNameSearching"
                                    type="text"
                                    placeholder="Suchen..."
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        this.changeValue('Search', e.target.value, true, true);
                                    }}
                                />
                            </div>
                            <DateRangeInput
                                onChangeOptionFrom={(value: string) => {
                                    this.changeValue('StartDate', value, true, true);
                                }}
                                onChangeOptionTo={(value: string) => {
                                    this.changeValue('EndDate', value, true, true);
                                }}
                            />
                            <div className={'text-right'}>
                                <Button size="sm" color="danger" onClick={ApiCourseCsv}>
                                    <span>CSV Export</span>
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input type="checkbox" checked={this.state.collapsed} onChange={this.onToggleCollapse} />{' '}
                            {TR.adminAllCourses_hide_past}
                        </Col>
                    </Row>
                    {!loading && (
                        <Row className="mt-2">
                            <Col>
                                <AdminCoursesTableBox
                                    listData={this.state.listData}
                                    renderTHeadLine={this.renderTHeadLineArrays}
                                    onClickSorting={this.onClickSorting}
                                    onClickDisabled={this.onClickDisabled}
                                    sortIcon={this.state.sortIcon}
                                    collapsed={this.state.collapsed}
                                />
                                <Paging
                                    totalCount={totalCount}
                                    pageSize={searchParams.PageSize}
                                    offset={searchParams.Offset}
                                    changeValue={this.changeValue}
                                />
                            </Col>
                        </Row>
                    )}
                </Container>
                <ModalMessageToEmail
                    isOpen={openModalMessage}
                    modalHeader={courseActive ? 'Kurs aktivieren?' : 'Kurs deaktivieren?'}
                    modalBody={`E-Mail an: ${courseProviderMail}`}
                    onClickYes={this.onClickEmailThat}
                    onClickNo={this.closeModal}
                    eMailToCourseProvider={(e: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState({ emailToCourseProvider: e.target.value });
                    }}
                />
                <Footer />
            </NetworkOverlay>
        );
    }

    private onClickEmailThat = () => {
        if (this.state.courseActive) {
            this.activateCourse();
        } else {
            this.deactivateCourse();
        }
    };

    private searchCourses = () => {
        ApiCourseList({ ...this.state.searchParams }, (sr) => {
            if (sr.OK) {
                this.setState({
                    listData: sr.Data ? sr.Data.Lines : [],
                    loading: false,
                    serverResponse: sr,
                    totalCount: sr.Data ? sr.Data.Count : 0,
                });
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };

    private onClickDisabled = (e: React.SyntheticEvent, str: string) => {
        if (str === 'active') {
            this.openModal(e);
            this.setState({ courseActive: true, openModalMessage: true });
        }
        if (str === 'deactive') {
            this.openModal(e);
            this.setState({ courseActive: false, openModalMessage: true });
        }
    };

    private onClickSorting = (sortField: string, index: number, sortIcon: ISortIcon) => {
        this.changeValue('Sort', sortField, true);
        const mySortIcon: ISortIcon[] = [];
        this.state.sortIcon.map(() => mySortIcon.push(ISortIcon.Sort));
        mySortIcon[index] = sortIcon;
        if (sortIcon === ISortIcon.Sort) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
        if (sortIcon === ISortIcon.SortUp) {
            mySortIcon[index] = ISortIcon.SortDown;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', true, true);
            });
        }
        if (sortIcon === ISortIcon.SortDown) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
    };

    private changeValue = (
        fieldName: string,
        value: string | boolean | number,
        reload: boolean = false,
        resetPaging: boolean = false
    ) => {
        const newParams = { ...this.state.searchParams };
        // @ts-ignore
        newParams[fieldName] = value;
        if (resetPaging) {
            newParams.Offset = 0;
        }
        if (reload) {
            this.setState({ searchParams: newParams }, this.searchCourses);
        } else {
            this.setState({ searchParams: newParams });
        }
    };

    private activateCourse = () => {
        this.setState({ loading: true, openModalMessage: false }, () => {
            ApiCourseActivate(
                { ID: this.state.courseProviderID, EmailMessage: this.state.emailToCourseProvider },
                (sr: ServerResponse) => {
                    this.searchCourses();
                }
            );
        });
    };

    private deactivateCourse = () => {
        this.setState({ loading: true, openModalMessage: false }, () => {
            ApiCourseDeactivate(
                { ID: this.state.courseProviderID, EmailMessage: this.state.emailToCourseProvider },
                (sr: ServerResponse) => {
                    this.searchCourses();
                }
            );
        });
    };

    private openModal = (e: React.SyntheticEvent) => {
        const cid = e.currentTarget.getAttribute('data-cid');
        const mail = e.currentTarget.getAttribute('data-mail');
        if (cid && mail) {
            this.setState({
                courseProviderID: cid,
                courseProviderMail: mail,
            });
        }
    };

    private onToggleCollapse = () => {
        this.setState((prevState: IState) => {
            return { ...prevState, collapsed: !prevState.collapsed };
        });
    };

    private closeModal = () => {
        this.setState({ openModalMessage: false });
    };
}



// WEBPACK FOOTER //
// ./src/views/adminAllCourses/AdminAllCourses.tsx